import Workload from './workload';

export default class Job extends Workload {
}
